import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
// import FormDialog from '../../../components/table/FormDialog';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import OpenTickets from './openTickets';
import ClosedTickets from './closedTickets';
import './ticketStatusStyles.css';
import { CommonConfig } from '../../../config/common-config';
import axios from 'axios';
import token from '../../../config/token';
import ItecService from '../itecService';
// import { cacheservice } from '../../../config/cacheservice';
import { setSelectedImc } from '../../services/store/actions/index';

// import Button from '@material-ui/core/Button';
// import axios from 'axios';
// import DataTable from './common/view';
// import SearchBox from '../../../components/table/SearchBox';
// import FormDialog from '../../../components/table/FormDialog';
// import { CommonConfig } from '../../../config/common-config';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    buttonBack: {
        background: '#4c4fa6',
        color: '#fff',
        padding: '12px 37px',
        borderRadius: '6px',
        fontFamily: 'Rubik',
        fontWeight: '500 !important',
        margin: '11px 0px 0px 0px',
        fontSize: 'medium',
        cursor: 'pointer',
        border: 'none',
    }
}));
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function TicketStatus() {
    // console.log('props78',props);
    const history = useHistory();
    const tokens = token();
    // const [AllImcs, setAllImcs] = useState([]);
    // const [searchQuery, setSearchQuery] = useState('');
    // // const [deletedata, setDeleteData] = useState(rows);
    // const [openBox, setOpenBox] = useState(false);
    // const [deleteMsg, setDeleteMsg] = useState('');
    // const [rows, setPendingInvoices] = useState([]);
    // const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const vertical = 'top';
    const horizontal = 'center';
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    // const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    // const dbname = tennantDetails.tennantName;
    // const invoiceId = rows.id;
    // // const [selectedImc, setselectedImc] = useState(dbname);
    const classes = useStyles();
    const [statusType, setStatusType] = useState('All');
    const [selectedImc, setselectedImc] = useState('');
    const [AllImcs, setAllImcs] = useState([]);
    const [itecSupportFlag, setItecSupportFlag] = useState(false);

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const location = useLocation();
    const dispatch = useDispatch({});
    const domainName = location && location.state && location.state.domainname;
    // console.log('domainName123', domainName);


    //console.log("dbname", dbname);
    //console.log("selectedImc", selectedImc);
    //console.log("usertype", usertype);

    // const headCells = [
    //     { id: 'ticketNumber', label: 'Ticket Number' },
    //     { id: 'clientId', label: 'Client ID' },

    //     { id: 'clientName', label: 'Timestamp' },
    //     { id: 'issueRelatesTo', label: 'issue relates to' },
    //     { id: 'timeStamp', label: 'Timestamp' },
    //     { id: 'currentStatus', label: 'Current Status' },
    // ];

    // const { breadCrumbLabel, breadCrumbPath } = props;

    useEffect(() => {
        setselectedImc(imcNameSelected);
        // cacheservice.getSupportFlag().subscribe(val => {
        //     if (usertype === 'SUPERADMIN' || usertype === 'itec') {
        //         setItecSupportFlag(val.count);
        //     }
        // });
        // if (usertype === 'SUPERADMIN' || usertype === 'itec') {
        //     setItecSupportFlag(true);
        // }
        // console.log('tokens', tokens, selectedImc)
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, tokens)
            .then((response) => setAllImcs(response.data.content))
            .catch((error) => {
                //console.log(error);
            });
    }, [tokens]);

    // componentDidMount() {
    //     this.getCandidates();
    //     this.props.history.push({
    //         state: { breadCrumb_label: this.props.breadCrumb_label }
    //     });
    // }

    // const HandleImcChange =(e)=> {
    // alert(e.target.value);

    // };

    // const handleSearchQuery = (searchData) => {
    //     //console.log(searchData);
    //     setSearchQuery(searchData);
    // };
    // const navigate = () => {
    //     history.push('/menu/raise-ticket');
    // };

    // const handleSave = () => {};

    // const handleClose = () => {
    //     setOpenBox(false);
    // };

    // const handleDelete = (data) => {
    //     if (data.empId) {
    //         axios
    //             .delete(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith/${selectedImc}/${data.empId}`)
    //             .then((response) => {
    //                 const { status } = response;
    //                 if (status === 200) {
    //                     const list = rows.filter((m) => m.empId !== data.empId);
    //                     setDeleteData({ rows: list });
    //                     setDeleteMsg('Core employee deleted successfully');
    //                     setOpenBox(true);
    //                 }
    //             })
    //             .catch((e) => {
    //                 //console.log(e);
    //             });
    //     }
    // };

    // const navigate = () => {
    //     history.push('/menu/Core');
    // };
    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
    //     return OptionList;
    // };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     axios
    //         .get(`${CommonConfig.dev.baseUrl}/api/auth/open-invoices/Advith/${e.target.value}?page=0&size=1000&sort=empId,desc`)
    //         .then((response) => {
    //             //console.log("response", response.data.content);
    //             setTotalReactPackages(response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             if (error.response.data) {
    //                 setTotalReactPackages([]);
    //             }
    //         });
    // };
    // const { searchQuery } = props;
    // const filtered = searchQuery ? rows.filter((row) => row.firstName.toLowerCase().startsWith(searchQuery.toLowerCase())) : rows;

    // Filtered Row query , but if there are any empty rows doesn't work
    // as per functionality of "some" it should have value

    // const filteredRow = searchQuery
    //     ? rows.filter((row) => {
    //           const query = searchQuery.toLowerCase().trim();
    //           //   //console.log(Object.keys(row) ,"Keys of ROW**** object.keys()");
    //           return headCells
    //               .map((col) => col.id)
    //               .some((key) => {
    //                   //console.log(row[key],"Value of ROW****row[key]");
    //                   return row[key].toString().toLowerCase().includes(query);
    //               });
    //       })
    //     : rows;

    // Filtered Row based on search for nested objects

    const setImc = (imcName) => {
        // console.log('e.target.value', imcName);
        setselectedImc(imcName);
        dispatch(setSelectedImc(imcName));
        setItecSupportFlag(false);
    };

    const handleChange = (e) => {
        setStatusType(e.target.value);
    };

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    const handleBackBtn = () => {
        history.push('/menu/support-ticketstatus');
        // cacheservice.sendSupportFlag(true);
    }

    return (
        <>
            <div>
                {itecSupportFlag ? (
                    <ItecService handleIMCType={setImc} />
                ) :
                    < span >
                        <Grid container spacing={3} className="main-container w100i" style={{ padding: '20px 0px 20px' }}>
                            {/* {usertype === 'SUPERADMIN' || usertype === 'itec' ? (
                                <Grid item xs={6} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="state" shrink>
                                            Select IMC{' '}
                                        </InputLabel>
                                        <Select
                                            native
                                            onChange={setImc}
                                            value={selectedImc}
                                            inputProps={{
                                                name: 'intclientName',
                                            }}
                                            className="bottom"
                                        >
                                            <option value="">Select IMC</option>
                                            {allImcsOptions(AllImcs)}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            ) : null} */}
                            <Grid item xs={6} sm={usertype === 'ADMIN' ? 6 : 6}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="book-application" className={classes.inLabel} shrink>
                                        Status
                                    </InputLabel>
                                    <Select
                                        native
                                        // disable
                                        // value={state.tally}
                                        onChange={(e) => {
                                            handleChange(e);
                                        }}
                                        // inputProps={{
                                        //     name: 'Is the firm liable for audit',
                                        //     id: 'book-application',
                                        // }}
                                        className={classes.bottomLine}
                                    >
                                        {/* <option aria-label="None" value="" /> */}
                                        <option value={'All'}>All</option>
                                        <option value={'Open'}>Open</option>
                                        <option value={'Inprogress'}>In Progress</option>
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* {usertype === 'SUPERADMIN' || usertype === 'itec' ? (
                                <span style={{ fontSize: '12px', marginLeft: '12px', color: '#4c4c4d' }}>*Select IMC to view the tickets</span>
                            ) : null} */}
                        </Grid>

                        <Card className="custom-table">
                            <OpenTickets statusType={statusType} selectedImc={domainName} />
                        </Card>
                        <Card className="custom-table mt30">
                            <ClosedTickets selectedImc={domainName} />
                        </Card>
                        {userTeam === 'ITeC Team' ? (<button className={classes.buttonBack} onClick={handleBackBtn}>Back</button>) : null}
                    </span>}
            </div>
        </>
    );
}
export default TicketStatus;
